export default class Localization {
  /**
   * @param {Object} localizations sent from CMS backend. Language specific
   * localization objects are sent based on IWAS website language setting.
   */
  constructor(localizations) {
    this.localizations = localizations;
  }

  /**
   * Localizes an English word / phrase.
   *
   * @param {string} english word or phrase. Used as key in localizations object.
   * @param {Object}[inputObj={}] inputObj contains key value pairs that will be
   * used to replace variable names that match the keys enclosed in {{}} within
   * the given english phrase.
   * @return {string} Localized word/phrase
   */
  localize(english, inputObj = {}) {
    let localization = this.getLocalization(english);

    const keyArray = Object.keys(inputObj);

    if (!keyArray.length) {
      // no string interpolation required
      return localization;
    } else {
      keyArray.forEach((key) => {
        const regex = new RegExp('{{' + key + '}}', 'g');

        localization = localization.replace(regex, inputObj[key]);
      });

      return localization;
    }
  }

  /**
   * @param {string} english original phrase
   * @returns {string} localization
   */
  getLocalization(english) {
    // this.localizations is null when website-language is EN
    if (this.localizations) {
      // returns the original english if a localization does not exist
      return this.localizations[english] || english;
    } else {
      return english;
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-js/models/BackendLocalization.js